export default __webpack_public_path__ + "static/tfl-brand-logo-ae6a2a7d372b6b305a2f1c26a9a03151.png";